module.exports = __webpack_public_path__ + "img/ИФ-1(А)-017-m.3e935b5a.png";